
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engage-v2/[client]/[agenda]",
      function () {
        return require("private-next-pages/engage-v2/[client]/[agenda].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engage-v2/[client]/[agenda]"])
      });
    }
  